import PopupArrow from '../Popup/PopupArrow'
import styles from './Tooltip.module.css'
import { Popup, Position } from '../Popup'
import type { TooltipProps } from './types'

function Tooltip(props: TooltipProps) {
  return (
    <Popup
      {...props}
      Anchor={PopupArrow}
      triggerEvents={['hover', 'focus']}
      contentClassName={styles.tooltipContent}
      contentWrapperClassName={styles.opacityTransition}
      popupOpenWrapperClassName={styles.opacityTransitionOpen}
      preferredPopupPosition={Position.TOP}
    />
  )
}

export default Tooltip
